import { formatDateTime } from '@utils/date';

import type { PeppolDeliveryStatus } from './peppol.types';

export const PEPPOL_STATUS_LABELS: Record<PeppolDeliveryStatus, string> = {
  NotSent: 'Niet verzonden',
  Created: 'In Billit, niet verzonden',
  Sent: 'Verzonden, wacht op aflevering',
  Delivered: 'Afgeleverd',
  Refused: 'Geweigerd',
  Failed: 'Mislukt',
};

/** "Al verzonden via Peppol op …" — why a document can't be sent via Peppol again. */
export function describePeppolAlreadySent(peppol: { status: PeppolDeliveryStatus; sentAt: string | null }): string {
  const when = peppol.sentAt ? ` op ${formatDateTime(peppol.sentAt)}` : '';
  return `Al verzonden via Peppol${when} (status: ${PEPPOL_STATUS_LABELS[peppol.status]}).`;
}
